<template>
  <div class="overlay">
    <div class="overlay__wrapper">
      <div class="overlay__content">
        <ul
          id="modal-content"
          class="modal__content-list modal__content-list--error"
        >
          <li class="modal__content-item modal__content-item--title">
            <span class="modal__title">
              <i class="icofont-exclamation-tringle"></i> {{ error.title }}
            </span>
            <span
              class="modal__close modal-close-action"
              @click="closeErrorModal"
            ></span>
          </li>
          <li class="modal__content-item modal__control">
            <p class="modal__control_header">{{ error.header }}</p>
            <p class="modal__control_text">
              {{ error.message }}
            </p>
            <div class="modal__control_action">
              <p class="modal__control_actionwrapper">
                <span
                  class="modal__control_cancel modal-close-action modal__error-button"
                  @click="closeErrorModal"
                >
                  {{ error.button }}
                </span>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ErrorModal",
  props: {
    //configdata: {
    //    type: Object,
    //    default: () => ({}),
    //},
    error: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    error: function (newError) {
      this.error.header = newError.header;
      this.error.message = newError.message;
      this.getPreviewImage();
    }
  },
  methods: {
    closeErrorModal() {
      this.$emit("close-error-message");
    }
  },
  computed: {
    config: function () {
      return configdata;
    },
    errors: function () {
      return this.errordata;
    }
  }
};
</script>
